module.exports = __webpack_public_path__ + "static/media/cartagena-16.de9dc475.jpg";